import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard, Calendar, MessageSquare, Users, Briefcase,
  Heart, BookOpen, Building2, PhoneCall, Settings
} from 'lucide-react';

const roleTabs = {
  agency_admin: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard/admin' },
    { icon: Calendar, label: 'Shifts', path: '/dashboard/admin/shifts' },
    { icon: Briefcase, label: 'Jobs', path: '/manage-jobs' },
    { icon: PhoneCall, label: 'Callbacks', path: '/callback-requests' },
    { icon: Settings, label: 'More', path: '/settings' },
  ],
  ceo: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard/ceo' },
    { icon: Calendar, label: 'Shifts', path: '/dashboard/admin/shifts' },
    { icon: Briefcase, label: 'Jobs', path: '/manage-jobs' },
    { icon: PhoneCall, label: 'Callbacks', path: '/callback-requests' },
    { icon: Settings, label: 'More', path: '/settings' },
  ],
  caregiver: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard/caregiver' },
    { icon: Calendar, label: 'Shifts', path: '/dashboard/caregiver' },
    { icon: MessageSquare, label: 'Messages', path: '/messaging' },
    { icon: BookOpen, label: 'Learning', path: '/learning' },
    { icon: Settings, label: 'More', path: '/settings' },
  ],
  client: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard/client' },
    { icon: Calendar, label: 'Schedule', path: '/dashboard/client/schedule' },
    { icon: Users, label: 'Caregivers', path: '/dashboard/client/caregivers' },
    { icon: Heart, label: 'Care Plan', path: '/dashboard/client/care-plan' },
    { icon: Settings, label: 'More', path: '/settings' },
  ],
  family: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard/family' },
    { icon: Heart, label: 'Member', path: '/dashboard/family/member' },
    { icon: Calendar, label: 'Schedule', path: '/dashboard/family/schedule' },
    { icon: BookOpen, label: 'Journals', path: '/care-journals' },
    { icon: Settings, label: 'More', path: '/settings' },
  ],
  developer: [
    { icon: LayoutDashboard, label: 'Overview', path: '/dashboard/developer' },
    { icon: Building2, label: 'Companies', path: '/dashboard/developer' },
    { icon: Users, label: 'Users', path: '/dashboard/developer' },
    { icon: Settings, label: 'More', path: '/settings' },
  ],
};

export function MobileBottomNav() {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !user) return null;

  const tabs = roleTabs[user.role] || [];
  if (!tabs.length) return null;

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 mobile-bottom-nav" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname === tab.path;
          return (
            <Link
              key={tab.path + tab.label}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-all duration-200 active:scale-95 ${
                isActive ? 'text-[#00A6A0]' : 'text-muted-foreground'
              }`}
              data-testid={`bottom-nav-${tab.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : ''}`} />
              <span className={`text-[10px] ${isActive ? 'font-semibold' : 'font-medium'}`}>
                {tab.label}
              </span>
              {isActive && (
                <span className="absolute top-0 w-8 h-0.5 rounded-full bg-[#00A6A0]" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileBottomNav;
